import { render, staticRenderFns } from "./SponsorshipDetails.vue?vue&type=template&id=01d97cdf&scoped=true&"
import script from "./SponsorshipDetails.vue?vue&type=script&lang=js&"
export * from "./SponsorshipDetails.vue?vue&type=script&lang=js&"
import style0 from "./SponsorshipDetails.vue?vue&type=style&index=0&id=01d97cdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d97cdf",
  null
  
)

export default component.exports